export const privateUsURL = "https://www.upik.de/en/v_upik_eupdate.cgi";
export const privateGermanURL = "https://www.upik.de/v_upik_eupdate.cgi";
export const imprintURL = "https://www.dnb.com/de-de/impressum.html";
export const bottomClickHereGermanURL = "https://www.upik.de/en/v_upik_anfrage.cgi";
export const bottomClickHereUsURL = "https://www.upik.de/v_upik_anfrage.cgi";
export const contactUpikRoutes = ["upik-en/contact-upik", "upik/kontaktaufnahme-upik"];
export const TermsOfUseUpikRoutes = ["upik-en/terms-of-use", "upik/nutzungsbedingungen"];
export const contactUpikInternationalURL = "https://www.dnb.com/en-gb/";
export const contactUpikUSCountries = {
    "columnFirst": [
        { name: "Albania / Kosovo / North Macedonia", link: "mailto:info.mk@dnb.com" },
        { name: "Australia", link: "https://www.illion.com.au/" },
        { name: "Austria", link: "https://www.dnb.com/de-de/produkte-services/dun-bradstreet/dnb-duns-nummer/" },
        { name: "Bangladesh", link: "https://www.dnbsame.com/" },
        { name: "Belgium", link: "https://www.altares.be/en/" },
        { name: "Bhutan", link: "https://www.dnbsame.com/" },
        { name: "Bosnia and Herzegovina", link: "https://www.dnb.com/bs-latn/" },
        { name: "Botswana / Lesotho / Namibia / Zimbabwe", link: "https://www.transunion.co.za/" },
        { name: "Brunei Darussalam", link: "http://dnbvietnam.com/" },
        { name: "Bulgaria", link: "https://www.icap.bg/en/" },
        { name: "Cambodia", link: "http://dnbvietnam.com/" },
        { name: "Canada", link: "https://www.dnb.com/ca-en/" },
        { name: "China Mainland", link: "http://www.dnbchina.com/" },
        { name: "Colombia", link: "https://www.informacolombia.com/" },
        { name: "Croatia", link: "https://www.dnb.com/hr-hr/" },
        { name: "Cyprus (Greece)", link: "https://www.icap.gr/en/" },
        { name: "Cyprus (Turkey)", link: "https://www.dnbturkey.com/" },
        { name: "Czech Republic", link: "https://www.dnb.com/cs-cz/" },
        { name: "Denmark", link: "https://www.dnb.com/da-dk/" },
        { name: "East Timor", link: "https://www.dnb.co.id/" },
        { name: "Egypt", link: "https://dnb.com.eg/" },
        { name: "Estonia", link: "https://www.dnb.com/et-ee/" },
        { name: "Finland", link: "https://www.dnb.com/fi-fi/" },
        { name: "France", link: "https://www.altares.com/fr/" },
        { name: "Germany", link: "https://www.bisnode.de/duns-request/" }
    ],
    "columnSecond": [
        { name: "Greece", link: "https://www.icap.gr/en/" },
        { name: "Hong Kong SAR", link: "http://www.dnb.com.hk/" },
        { name: "Hungary", link: "https://www.dnb.com/hu-hu/" },
        { name: "Iceland", link: "https://www.creditinfo.is/" },
        { name: "India", link: "https://www.dnb.co.in/" },
        { name: "Indonesia", link: "https://www.dnb.co.id/" },
        { name: "Ireland", link: "https://www.dnb.com/ie/" },
        { name: "Israel", link: "https://www.dbisrael.co.il/en/" },
        { name: "Italy", link: "https://www.dnb.it/en/" },
        { name: "Japan", link: "http://www.tsr-net.co.jp/" },
        { name: "Korea", link: "http://www.nicednb.com/" },
        { name: "Laos", link: "http://dnbvietnam.com/" },
        { name: "Latvia", link: "https://www.dnb.com/lv-lv" },
        { name: "Lithuania", link: "http://www.baltfakta.eu/" },
        { name: "Mahgreb", link: "http://www.iaa-dnb.com/" },
        { name: "Malaysia", link: "http://www.dnb.com.my/" },
        { name: "Maldives", link: "https://www.dnbsame.com/" },
        { name: "Malta", link: "https://mt.creditinfo.com/" },
        { name: "Middle East", link: "https://www.dnbsame.com/" },
        { name: "Myanmar", link: "http://dnbvietnam.com/" },
        { name: "Nepal", link: "https://www.dnbsame.com/" },
        { name: "Netherlands", link: "https://www.altares.nl/en/" },
        { name: "New Zealand", link: "https://www.illiontenancy.co.nz/" },
        { name: "Northern & Central Africa", link: "http://dnbsame.com/" },
        { name: "Norway", link: "https://www.dnb.com/no/" },
    ],
    "columnThird": [
        { name: "Pakistan", link: "https://www.dnbsame.com/" },
        { name: "Philippines", link: "http://www.dnb.com.ph/" },
        { name: "Poland", link: "https://www.dnb.com/pl-pl/" },
        { name: "Portugal", link: "https://www.informadb.pt/contactos/solicitar-reuniao/" },
        { name: "Romania", link: "https://icap.ro/en/" },
        { name: "Russia and Former Soviet Republics", link: "https://www.dnb.ru/en/" },
        { name: "Serbia", link: "https://www.dnb.com/sr-latn/" },
        { name: "Singapore", link: "http://www.dnb.com.sg/" },
        { name: "Slovakia", link: "https://www.dnb.com/sk-sk/" },
        { name: "Slovenia", link: "https://www.dnb.com/sl-si/" },
        { name: "South America/Latin America", link: "https://www.cialdnb.com/" },
        { name: "South Africa", link: "https://www.transunion.co.za/" },
        { name: "Spain", link: "https://www.informa.es/en/contacto" },
        { name: "Sri Lanka", link: "https://www.dnbsame.com/" },
        { name: "Sweden", link: "https://www.dnb.com/sv-se/" },
        { name: "Switzerland", link: "https://www.bisnode.ch/en-ch/" },
        { name: "Taiwan Region", link: "https://www.dnb.com.tw/" },
        { name: "Thailand", link: "http://www.dnb.co.th/" },
        { name: "Türkiye", link: "https://www.crif.com.tr/en/" },
        { name: "UAE", link: "https://dnbuae.com/" },
        { name: "United Kingdom", link: "https://www.dnb.co.uk/" },
        { name: "United States", link: "https://www.dnb.com/" },
        { name: "Vietnam", link: "http://dnbvietnam.com/" },
    ]
};
export const contactUpikGermanCountries = {
    "columnFirst": [
        { name: "Ägypten", link: "https://dnb.com.eg/" },
        { name: "Albanien / Kosovo / Nordmazedonien", link: "mailto:info.mk@dnb.com" },
        { name: "Australien", link: "https://www.illion.com.au/" },
        { name: "Bangladesch", link: "https://www.dnbsame.com/" },
        { name: "Belgien", link: "https://www.altares.be/en/" },
        { name: "Bhutan", link: "https://www.dnbsame.com/" },
        { name: "Bosnien und Herzegowina", link: "https://www.dnb.com/bs-latn/" },
        { name: "Botswana / Lesotho / Namibia / Simbabwe", link: "https://www.transunion.co.za/" },
        { name: "Brunei Darussalam", link: "http://dnbvietnam.com/" },
        { name: "Bulgarien", link: "https://www.icap.bg/en/" },
        { name: "China Festland", link: "http://www.dnbchina.com/" },
        { name: "Dänemark", link: "https://www.dnb.com/da-dk/" },
        { name: "Deutschland", link: "https://www.dnb.com/de-de/duns-request/" },
        { name: "Estland", link: "https://www.dnb.com/et-ee/" },
        { name: "Frankreich", link: "https://www.altares.com/fr/" },
        { name: "Finnland", link: "https://www.dnb.com/fi-fi/" },
        { name: "Griechenland", link: "https://www.icap.gr/en/" },
        { name: "Großbritannien", link: "https://www.dnb.co.uk/" },
        { name: "SVR Hongkong", link: "http://www.dnb.com.hk/" },
        { name: "Indien", link: "https://www.dnb.co.in/" },
        { name: "Indonesien", link: "https://www.dnb.co.id/" },
        { name: "Irland", link: "https://www.dnb.com/ie/" },
        { name: "Island", link: "https://www.creditinfo.is/" },
        { name: "Israel", link: "https://www.dbisrael.co.il/en/" },
        { name: "Italien", link: "https://www.dnb.it/en/" },
    ],
    "columnSecond": [
        { name: "Japan", link: "http://www.tsr-net.co.jp/" },
        { name: "Kambodscha", link: "http://dnbvietnam.com/" },
        { name: "Kanada", link: "https://www.dnb.com/ca-en/" },
        { name: "Korea", link: "http://www.nicednb.com/" },
        { name: "Kolumbien", link: "https://www.informacolombia.com/" },
        { name: "Kroatien", link: "https://www.dnb.com/hr-hr/" },
        { name: "Laos", link: "http://dnbvietnam.com/" },
        { name: "Lettland", link: "https://www.dnb.com/lv-lv" },
        { name: "Litauen", link: "http://www.baltfakta.eu/" },
        { name: "Mahgreb", link: "http://www.iaa-dnb.com/" },
        { name: "Malaysia", link: "http://www.dnb.com.my/" },
        { name: "Malta", link: "https://mt.creditinfo.com/" },
        { name: "Malediven", link: "https://www.dnbsame.com/" },
        { name: "Myanmar (Birma)", link: "http://dnbvietnam.com/" },
        { name: "Naher Osten", link: "https://www.dnbsame.com/" },
        { name: "Nepal", link: "https://www.dnbsame.com/" },
        { name: "Neuseeland", link: "https://www.illion.com.au/" },
        { name: "Niederlande", link: "https://www.altares.nl/" },
        { name: "Nord- und Zentralafrika", link: "http://dnbsame.com/" },
        { name: "Norwegen", link: "https://www.dnb.com/no/" },
        { name: "Österreich", link: "https://www.dnb.com/de-at/produkte-services/dun-bradstreet/db-d-u-n-s-number/" },
        { name: "Osttimor", link: "https://www.dnb.co.id/" },
        { name: "Pakistan", link: "https://www.dnbsame.com/" },
        { name: "Philippinen", link: "http://www.dnb.com.ph/" },
        { name: "Polen", link: "https://www.dnb.com/pl-pl/" },
    ],
    "columnThird": [
        { name: "Portugal", link: "https://www.informadb.pt/contactos/solicitar-reuniao/" },
        { name: "Rumänien", link: "https://icap.ro/en/" },
        { name: "Russland und ehemalige Sowjetrepubliken", link: "https://www.dnb.ru/en/" },
        { name: "Schweden", link: "https://www.dnb.com/sv-se/" },
        { name: "Schweiz", link: "https://www.dnb.com/de-ch/produkte-services/dun-bradstreet/duns-nummer/" },
        { name: "Serbien", link: "https://www.dnb.com/sr-latn/" },
        { name: "Singapur", link: "http://www.dnb.com.sg/" },
        { name: "Slovakei", link: "https://www.dnb.com/sk-sk/" },
        { name: "Slowenien", link: "https://www.dnb.com/sl-si/" },
        { name: "Spanien", link: "https://www.informa.es/en/contacto" },
        { name: "Sri Lanka", link: "https://www.dnbsame.com/" },
        { name: "Südafrika", link: "https://www.transunion.co.za/" },
        { name: "Süd/-Lateinamerika", link: "https://www.cialdnb.com/" },
        { name: "Region Taiwan", link: "https://www.dnb.com.tw/" },
        { name: "Thailand", link: "http://www.dnb.co.th/" },
        { name: "Tschechien", link: "https://www.dnb.com/cs-cz/" },
        { name: "Türkei", link: "https://www.crif.com.tr/en/" },
        { name: "USA", link: "https://www.dnb.com/" },
        { name: "Ungarn", link: "https://www.dnb.com/hu-hu/" },
        { name: "VAE", link: "https://dnbuae.com/" },
        { name: "Vietnam", link: "http://dnbvietnam.com/" },
        { name: "Zypern (Griechenland)", link: "https://www.icap.gr/en/" },
        { name: "Zypern (Türkei)", link: "https://www.dnbturkey.com/" },
    ]
};
